<div class="training-feedback">
  <app-page *ngIf="feedback">
    <div class="top-cta">
      <dx-button
        [text]="'COMMON.BACK' | translate"
        icon="back"
        type="default"
        class="integration-btn"
        (click)="navigateBack()"
      >
      </dx-button>
      <div class="top-cta-right">
        <dx-button
          *ngIf="pagesData.length"
          [text]="'COMMON.PRINT' | translate"
          type="normal"
          class="integration-btn"
          (onClick)="print()">
        </dx-button>
      </div>
    </div>
    <app-panel>
      <div id="print-section">
        <app-page-title
          [title]="
            ('TRAINING.FEEDBACK.SURVEY-RESULT' | translate) +
            ' — ' +
            (feedback.name || '')
          "
        >
        </app-page-title>
        <div *ngIf="feedback" class="survey-subtitle">
          {{ feedback.date }} · {{ "COMMON.FIELDS.TRAINER" | translate }}: {{ feedback.trainer }}
        </div>

        <div *ngIf="!pagesData.length" class="no-data-message">
          {{ "TRAINING.FEEDBACK.NO-FEEDBACK" | translate }}
        </div>

        <app-panel *ngIf="pagesData.length">
          <div class="survey-overview">
            <div class="survey-overview-overall">
              <div class="survey-overview-overall-label">
                {{ "TRAINING.FEEDBACK.OVERALL-RATING" | translate | uppercase }}
              </div>
              <div class="survey-overview-overall-score">
                <span class="survey-overview-overall-score-value">
                  {{ overallRating | number: "1.1-1" }}
                </span>
                <span class="survey-overview-overall-score-max">
                  /{{ maxScore }}
                </span>
              </div>
              <div class="feedback-rating feedback-rating-readonly feedback-rating-hero">
                <span
                  *ngFor="let s of defaultRatings"
                  class="feedback-rating-star"
                  [class.active]="s <= overallRating"
                >{{ s <= overallRating ? '★' : '☆' }}</span>
              </div>
              <div 
                class="survey-overview-overall-meta" 
                *ngIf="feedback && feedback.completedCount !== 0"
               >
                  {{ feedback.participants }} {{ "COMMON.OF" | translate }}
                  {{ feedback.completedCount }} {{ "TRAINING.FEEDBACK.RESPONSES" | translate}}
                  ·
                  {{ (feedback.participants / feedback.completedCount * 100) | number: "1.0-0" }}%
                  {{ "TRAINING.FEEDBACK.RESPONSE-RATE" | translate }}
               </div>
            </div>

            <div
              class="survey-overview-stat"
              *ngFor="let page of pagesData"
              [class.highest]="page === highestRatedPage"
              [class.lowest]="page === lowestRatedPage"
            >
              <div class="survey-overview-stat-title">{{ page.title }}</div>
              <div class="survey-overview-stat-score" *ngIf="page.averageScore">
                <span class="survey-overview-stat-score-value">
                  {{ page.averageScore | number: "1.1-1" }}
                </span>
                <span class="survey-overview-stat-score-max">/{{ maxScore }}</span>
                <span class="feedback-rating feedback-rating-readonly feedback-rating-medium">
                  <span
                    *ngFor="let s of defaultRatings"
                    class="feedback-rating-star"
                    [class.active]="s <= page.averageScore"
                  >{{ s <= page.averageScore ? '★' : '☆' }}</span>
                </span>
              </div>
              <div class="survey-overview-stat-meta">
                {{ page.questionCount }} {{ "TRAINING.FEEDBACK.QUESTIONS" | translate }} ·
                <ng-container *ngIf="page === highestRatedPage">
                  {{ "TRAINING.FEEDBACK.HIGHEST-RATED" | translate }}
                </ng-container>
                <ng-container *ngIf="page === lowestRatedPage">
                  {{ "TRAINING.FEEDBACK.LOWEST-RATED" | translate }}
                </ng-container>
                <ng-container *ngIf="page !== highestRatedPage && page !== lowestRatedPage">
                  {{ page.responseCount }} {{ "TRAINING.FEEDBACK.RESPONSES" | translate }}
                </ng-container>
              </div>
            </div>
          </div>
        </app-panel>

        <app-panel *ngFor="let page of pagesData" class="question-section">
          <div class="question-title">{{ page.title }}</div>
          <div class="survey-section-meta">
            {{ page.questionCount }} {{ "TRAINING.FEEDBACK.QUESTIONS" | translate }} ·
            {{ page.responseCount }} {{ "TRAINING.FEEDBACK.RESPONSES" | translate }} ·
            {{ "TRAINING.FEEDBACK.MORE-STARS-BETTER" | translate }}
          </div>

          <ng-container *ngFor="let question of page.questions">
            <div class="survey-question" *ngIf="question.distribution">
              <div class="survey-question-overview">
                <div class="survey-question-text">{{ question.question }}</div>
                <div class="survey-question-responses">
                  {{ question.responseCount }} {{ "TRAINING.FEEDBACK.RESPONSES" | translate }}
                </div>
              </div>
              <div class="survey-question-body">
                <div class="survey-question-score" *ngIf="question.averageScore">
                  <span class="feedback-rating feedback-rating-readonly">
                    <span
                      *ngFor="let s of getRatingsRange(question)"
                      class="feedback-rating-star"
                      [class.active]="s <= question.averageScore"
                    >{{ s <= question.averageScore ? '★' : '☆' }}</span>
                  </span>
                  <b>{{ question.averageScore | number: "1.1-1" }}</b>
                </div>
                <div class="survey-question-distribution">
                  <div class="survey-question-distribution-row" *ngFor="let s of getRatingsRangeDesc(question)">
                    <span class="survey-question-distribution-label">{{ s }} ★</span>
                    <div class="survey-question-distribution-bar">
                      <div
                        class="survey-question-distribution-bar-fill"
                        [ngStyle]="{
                          'width.%': getDistributionWidth(question, s),
                          opacity: getDistributionOpacity(question, s)
                        }"
                      ></div>
                    </div>
                    <span class="survey-question-distribution-count">
                      {{ question.distribution[s] || 0 }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div 
              class="survey-question survey-question-text-only" 
              *ngIf="!question.distribution"
            >
              <div class="survey-question-text-container">
                <p class="survey-question-text">{{ question.question }}</p>
                <ul class="question-options">
                  <li *ngFor="let option of question.answers">{{ option }}</li>
                </ul>
              </div>
            </div>
          </ng-container>
        </app-panel>
      </div>
    </app-panel>
  </app-page>
</div>